import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface VirtualizedListScrollBorderClasses {
	root: string;
	active: string;
	scrollEnd: string;
	scrolled: string;
}

export const getVirtualizedListScrollBorderClass = (slot: string) =>
	generateUtilityClass('VirtualizedListScrollBorder', slot);

export const virtualizedListScrollBorderClasses = generateUtilityClasses<
	keyof VirtualizedListScrollBorderClasses
>('VirtualizedListScrollBorder', ['root', 'active', 'scrollEnd', 'scrolled']);
export default virtualizedListScrollBorderClasses;
